module.exports = __webpack_public_path__ + "img/craft-beer.1cf63226.svg";